var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.files.length > 0)?_c('b-row',[_c('b-col',{staticClass:"mt-2",attrs:{"sm":"12"}},[_c('strong',[_vm._v("Los archivos adjuntos")]),_c('hr')]),_c('b-col',{attrs:{"sm":"12"}},[_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.files),function(ref,index){
var url = ref.url;
var value = ref.value;
return _c('li',{key:index},[_c('a',{attrs:{"href":value,"target":"_blank"}},[_vm._v(" Archivo "+_vm._s(index + 1)+" ")])])}),0)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }